<template>
  <v-card class="pa-6 elevation-1">
    <v-card-title class="text-uppercase">Cấu hình Thời gian Nhập điểm</v-card-title>
    <v-divider />
    <v-card-text>
      <config-section department="Cơ sở A" grade="Khối 10" :type="type" v-if="canViewA" />
      <v-divider class="my-6" v-if="canViewA && canView1" />
      <config-section department="Cơ sở 1" grade="Khối 10" :type="type" v-if="canView1" />
    </v-card-text>
  </v-card>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import {get} from 'lodash'
import ConfigSection from './ConfigSection.vue'
export default {
  components: {ConfigSection},
  computed: {
    ...mapGetters('auth', ['user']),
    type() {
      return this.$helpers.CV_DEADLINE_TYPE.RESULT_FILL
    },
    userDepartment() {
      return get(this.user, 'department', '')
    },
    canViewA() {
      if (this.userDepartment === 'both') return true
      return this.userDepartment === 'Cơ sở A'
    },
    canView1() {
      if (this.userDepartment === 'both') return true
      return this.userDepartment === 'Cơ sở 1'
    },
  },
  methods: {...mapActions({fetchItems: 'cvDeadline/fetchItems'})},
  async mounted() {
    await this.fetchItems({type: this.type})
  },
}
</script>